var _path, _line, _line2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaCardImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54101 23.6518C8.01111 23.8074 7.45537 23.504 7.29972 22.9741L4.43363 13.2164C4.27798 12.6865 4.58138 12.1307 5.11128 11.9751L22.0694 6.99406C22.5993 6.83841 23.155 7.14181 23.3106 7.67171L26.1767 17.4295C26.3324 17.9594 26.029 18.5151 25.4991 18.6708L8.54101 23.6518Z",
    fill: "#E8CD4E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.029,
    y1: 11.6787,
    x2: 13.3442,
    y2: 14.2471,
    stroke: "#F4DD73"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.7523,
    y1: 13.7944,
    x2: 14.3424,
    y2: 16.2476,
    stroke: "#F4DD73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.479 15.9102L15.2024 18.2676",
    stroke: "#F4DD73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27609 16.6364C8.15568 16.2086 8.9451 15.7325 9.37293 15.6121C9.80075 15.4917 10.7226 15.4862 10.843 15.914L10.9032 16.1279L8.33629 16.8503M9.71967 14.3833C9.76757 14.5535 9.74589 14.7358 9.65942 14.89C9.57294 15.0442 9.42874 15.1577 9.25854 15.2056C9.08834 15.2535 8.90608 15.2319 8.75187 15.1454C8.59765 15.0589 8.4841 14.9147 8.43619 14.7445C8.38829 14.5743 8.40997 14.3921 8.49644 14.2378C8.58292 14.0836 8.72712 13.9701 8.89732 13.9222C9.06752 13.8743 9.24978 13.8959 9.404 13.9824C9.55822 14.0689 9.67177 14.2131 9.71967 14.3833ZM6.91191 14.2501L7.75476 17.2449C7.78669 17.3583 7.86239 17.4545 7.9652 17.5121C8.06802 17.5698 8.18952 17.5842 8.30299 17.5523L11.2978 16.7094C11.4112 16.6775 11.5074 16.6018 11.565 16.499C11.6227 16.3962 11.6371 16.2747 11.6052 16.1612L10.7623 13.1664C10.7304 13.053 10.6547 12.9568 10.5519 12.8992C10.4491 12.8415 10.3276 12.8271 10.2141 12.859L7.21933 13.7019C7.10586 13.7338 7.00973 13.8095 6.95208 13.9123C6.89442 14.0151 6.87998 14.1366 6.91191 14.2501Z",
    fill: "#D3BA49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardImage);
export default __webpack_public_path__ + "static/media/visa_card_image.5fd387da63185281c00b850e4a1fb521.svg";
export { ForwardRef as ReactComponent };